<app-breadcrumbs [title]="'MENU.ADMINISTRATION.DELIVERY_ZONES'" [first]="'MENU.ADMINISTRATION.DELIVERY_ZONES'"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="authorities.create" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="plus" [text]="'SHARED.CREATE' | translate" type="success" [routerLink]="'./new'"></dx-button>
</div>

<div class="row">
    <dx-data-grid #table 
                    class="col-12"
                    [dataSource]="dataSource"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [showRowLines]="false"
                    [showColumnLines]="false"
                    [hoverStateEnabled]="true"
                    [allowColumnResizing]="true"
                    [allowColumnReordering]="true"
                    columnResizingMode="nextColumn"
                    [masterDetail]="{ enabled: true, template: 'details'}"
    >
        <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <dxo-state-storing [enabled]="true" [type]="'custom'" [customLoad]="loadGridState" [customSave]="saveGridState"></dxo-state-storing>
    
    
        <dxi-column dataField="name" dataType="string" sortOrder="asc" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>
    
        <dxi-column *ngIf="authService.userType == 'SYSTEM'" dataField="companyId" [filterOperations]= "['=']" dataType="string" [allowFiltering]="true" [allowSorting]="false" [caption]="'COMPANIES.COMPANY' | translate"></dxi-column>
    
        <dxi-column cellTemplate="actionsTemplate" *ngIf="editable || deletable" [allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'"></dxi-column>
    
        <div *dxTemplate="let template of 'actionsTemplate'">
            <span *ngIf="editable" class="table-icon ti-eye" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" [routerLink]="['./', template.data.id]"></span>
            <span *ngIf="deletable" class="table-icon dx-icon-trash" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="delete(template.data.id)"></span>
        </div>
    
        <div *dxTemplate="let template of 'details'">
            <div class="container">
                <div class="row mt-3">
                    <div class="col-12">
                        <span class="details-title">{{ 'MENU.DATA_MANAGEMENT.MUNICIPALITIES' | translate }}</span>
                        <hr class="wsh-hr hr-margin">
                        <div class="row">
                            <div class="col-12">
                                <dx-data-grid #productsGrid [dataSource]="template.data.municipalities" [showColumnLines]="false" [showRowLines]="true" [showBorders]="true"
                                              [rowAlternationEnabled]="true">
                                    <dxi-column dataField="name" dataType="string" [allowEditing]="false" [allowFiltering]="false" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>
                                    <dxi-column dataField="description" dataType="string" [allowEditing]="false" [allowFiltering]="false" [allowSorting]="true" [caption]="'SHARED.DESCRIPTION' | translate"></dxi-column>
                                </dx-data-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dx-data-grid>
</div>